var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-router',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Feature voting'),expression:"'Feature voting'"}],staticClass:"inbox",attrs:{"to":{name: (_vm.$isPatreon) ? 'SessionPatreonVoting' : 'CommunityVoting'}}},[_c('div',{staticClass:"inbox-icon"},[_c('i',{staticClass:"fa-solid fa-check-to-slot"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }